
import { SismoazurEventParameter } from '@/types'
import Vue from 'vue'

export default Vue.extend({
  props: {
    events: {
      type: Array as () => SismoazurEventParameter[],
      default: () => []
    },
    focusEvent: {
      type: Object as () => SismoazurEventParameter
    }
  },
  computed: {
    reverseEventList () {
      return this.events.map((x: SismoazurEventParameter) => x).reverse()
    }
  },
  methods: {
    handleDownload () {
      const csv = [
        [
          'region',
          'time',
          'latitude',
          'longitude',
          'depth(fmnear)[km]',
          'magnitude',
          'magnitude_type',
          'index_of_confidence',
          'quality',
          'rms',
          'nb_component',
          'strike',
          'dip',
          'rake'
        ].join(',')
      ]
      for (const event of this.events) {
        const region = event._full_region.city != null ? event._full_region.region.toUpperCase() : event._region?.toUpperCase()
        csv.push([
          `"${region}"`,
          event._po.time.value,
          `${event._po.latitude.value}`,
          `${event._po.longitude.value}`,
          `${event._fm._extra.depth}`,
          `${event._fm._mag.mag.value}`,
          event._fm._mag.type,
          event._fm._extra.index_of_confidence,
          event._fm._extra.quality,
          `${event._fm._extra.rms}`,
          `${event._fm._extra.nb_component}`,
          `${event._fm.nodal_planes.nodal_plane1.strike.value}`,
          `${event._fm.nodal_planes.nodal_plane1.dip.value}`,
          `${event._fm.nodal_planes.nodal_plane1.rake.value}`
        ].join(','))
      }
      console.log(csv.join('\n'))
      this.$refs.downloadLink.href = `data:text/csv;base64,${btoa(csv.join('\n'))}`
      this.$refs.downloadLink.click()
    }
  }
})
